import { useTranslations } from "contexts/LocalizationContext";
import { Flex, Heading, ModalCloseButton } from "@chakra-ui/react";
import { Form } from "./Form";

export const LegalPartnersForm = () => {
  const translations = useTranslations();
  return (
    <Flex p={10} flexDir="column">
      <Flex pb={6} align="center" justify="space-between">
        <Heading variant="h3" as="h3">
          {translations("form_become_a_partner")}
        </Heading>
        <ModalCloseButton size="md" color="primary.900" />
      </Flex>
      <Form />
    </Flex>
  );
};
